/* eslint-disable */
import React from "react";
import { Box, useMantineTheme } from "@mantine/core";
import { BRANDING } from "config/branding";

const positionToStyle = (pos: string) => {
  switch (pos) {
    case "top-left":
      return {
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "6vh 6vw",
      };
    case "top-right":
      return {
        alignItems: "flex-start",
        justifyContent: "flex-end",
        padding: "6vh 6vw",
      };
    case "bottom-left":
      return {
        alignItems: "flex-end",
        justifyContent: "flex-start",
        padding: "6vh 6vw",
      };
    case "bottom-right":
      return {
        alignItems: "flex-end",
        justifyContent: "flex-end",
        padding: "6vh 6vw",
      };
    case "center":
    default:
      return { alignItems: "center", justifyContent: "center" };
  }
};

export default function BackgroundWatermark() {
  const theme = useMantineTheme();
  const wm = BRANDING?.watermark;

  if (!wm?.enabled) return null;

  const posStyle = positionToStyle(wm.position);

  const size = typeof wm.sizeVw === "number" ? `${wm.sizeVw}vw` : "40vw";

  const finalOpacity = typeof wm.opacity === "number" ? wm.opacity : 0.08;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        pointerEvents: "none",
        zIndex: 1,
        ...posStyle,
      }}
      aria-hidden
    >
      <img
        src={BRANDING.logoUrl}
        alt="Watermark"
        style={{
          width: size,
          height: "auto",
          maxHeight: "80vh",
          objectFit: "contain",
          opacity: finalOpacity,
          filter:
            theme.colorScheme === "dark"
              ? "invert(1) grayscale(100%)"
              : "grayscale(100%)",
          userSelect: "none",
        }}
      />
    </Box>
  );
}
